import { render, staticRenderFns } from "./SNPSelect.vue?vue&type=template&id=19a6c9fd&"
import script from "./SNPSelect.vue?vue&type=script&lang=ts&"
export * from "./SNPSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports